import Seats01 from "../../../../content/posts/2020-03-06-women-in-assembly/Seats01.js";
import Seats02 from "../../../../content/posts/2020-03-06-women-in-assembly/Seats02.js";
import Seats03V from "../../../../content/posts/2020-03-06-women-in-assembly/Seats03V.js";
import React from 'react';
export default {
  Seats01,
  Seats02,
  Seats03V,
  React
};